import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from '@/libs/acl/ability'

export default function useMeetingTagsList() {

    //User toast
    const toast = useToast()

    const refMeetingTagListTable = ref(null)

    const tableColumns = [
        {key: 'tag', sortable: true},
        {key: 'description'},
        {key: 'demo', label:'LABEL'},
        {key: 'action'}
    ]

    const perPage = ref(10)
    const totalMeetingTags = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
        const localItemsCount = refMeetingTagListTable.value ? refMeetingTagListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalMeetingTags.value,
        }
    })

    const refetchData = () => {
        refMeetingTagListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchMeetingTags = (ctx, callback) => {
        store.dispatch('setting-meetingtag/fetchMeetingTags',{
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response =>{
            const {meetingtags, total} = response.data
            callback(meetingtags)
            totalMeetingTags.value = total
        
        })
        .catch((error) => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching meeting tags list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger'
                }
            })
        })
    }

    return {
        fetchMeetingTags,
        tableColumns,
        perPage,
        currentPage,
        totalMeetingTags,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refMeetingTagListTable,
        ability,
        refetchData
    }

}